import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import { createStore, applyMiddleware, compose } from 'redux'
import axiosMiddleware from 'redux-axios-middleware'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import multi from 'redux-multi'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { PersistGate } from 'redux-persist/integration/react'
import axios from 'axios'

import './styles/main.scss'
import * as serviceWorker from './serviceWorker'
import reducers from './reducers'
// import { Constants } from './constants'
import { getNewAccessToken, userLogout, sendFlashMessage } from './actions'
import AppRoutes from './Routes'
import { history } from './history'

const client = axios.create({
    baseURL: 'http://127.0.0.1:3001',
    //  baseURL: 'https://api.akolade.lightrains.com',
    responseType: 'json'
})

const persistConfig = {
    key: 'root',
    storage
}

const middlewareConfig = {
    interceptors: {
        response: [
            {
                error: ({ getState, dispatch, getSourceAction }, error) => {
                    console.log(error)
                    if (
                        error.response.status &&
                        error.response.status === 401
                    ) {
                        if (error.response.data.message === 'Expired token') {
                            const state = getState()
                            const authToken = state.user.user.authorization
                            const formData = {
                                refreshtoken: state.user.user.refreshtoken,
                                handle: state.user.user.handle
                            }
                            dispatch(getNewAccessToken(authToken, formData))
                        }
                        if (error.response.data.message === 'reauthenticate') {
                            dispatch(userLogout())
                            dispatch(
                                sendFlashMessage(
                                    error.response.data.message,
                                    'warning'
                                )
                            )
                            history.push(AppRoutes.login)
                        }
                    }

                    // Response Error Interception
                    return Promise.reject(error)
                }
            }
        ]
    }
}

const persistedReducer = persistReducer(persistConfig, reducers)
const composedEnhancers = compose(
    applyMiddleware(thunk, multi, axiosMiddleware(client, middlewareConfig))
)

const store = createStore(persistedReducer, {}, composedEnhancers)
const persistor = persistStore(store)

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register()
